import React, { useState } from 'react';
import { Card, Row, Col, Image } from 'react-bootstrap';
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto';

const Dashboard = () => {
  const [dashboardCounts, setDashboardCounts] = useState({
    district: 10,
    city: 5,
    zone: 8,
    area: 15,
    brands: [
      { label: 'Tata', value: 250 },
      { label: 'Aashirvaad', value: 400 },
      { label: 'Nestle', value: 180 },
      { label: 'Surf Excel', value: 310 },
    ],
    shopData: [50, 70, 60, 90, 110],
    businessStats: {
      active: 45,
      inactive: 20,
    },
    banners: [
      {
        img: 'https://images.unsplash.com/photo-1604908177521-fbdc10d6d3ab',
        shop: 'Ocean Catch',
        title: 'Seafood Supplies',
        description: 'Fresh seafood directly from the coast',
        status: 'Active',
      },
      {
        img: 'https://images.unsplash.com/photo-1584308972509-2c93ac74f05a',
        shop: 'Green Farm',
        title: 'Organic Chicken',
        description: 'Responsibly raised chicken products',
        status: 'Active',
      },
      {
        img: 'https://images.unsplash.com/photo-1605477760019-204d1b7d9aa1',
        shop: 'Meat Master',
        title: 'Premium Meat',
        description: 'Grass-fed & hormone-free meat cuts',
        status: 'Inactive',
      },
    ]
  });

  const barChartData = {
    labels: dashboardCounts.brands.map((b) => b.label),
    datasets: [
      {
        label: 'Brand Sales',
        data: dashboardCounts.brands.map((b) => b.value),
        backgroundColor: ['#4bc0c0', '#ff6384', '#36a2eb', '#ff9f40'],
      },
    ],
  };

  const pieChartData = {
    labels: ['Shop 1', 'Shop 2', 'Shop 3', 'Shop 4', 'Shop 5'],
    datasets: [
      {
        label: 'Shops',
        data: dashboardCounts.shopData,
        backgroundColor: ['#36a2eb', '#ff6384', '#4bc0c0', '#ffcd56', '#9966ff'],
      },
    ],
  };

  return (
    <div className="container-fluid">
      {/* Count Cards */}
      <Row className="mb-4">
        {['District', 'City', 'Zone', 'Area'].map((label, idx) => (
          <Col xl={3} sm={6} key={idx}>
            <Card className="shadow-sm">
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div>
                  <h5 className="text-muted">{label}</h5>
                  <h3 className="text-dark mb-0">{dashboardCounts[label.toLowerCase()]}</h3>
                </div>
                <div className="bg-light rounded-circle p-3">
                  <i className="fas fa-map-marker-alt text-primary fs-4"></i>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Charts */}
      <Row>
        <Col xl={6}>
          <Card className="shadow-sm">
            <Card.Header>
              <h5 className="mb-0">Top Selling Brands</h5>
            </Card.Header>
            <Card.Body>
              <Bar data={barChartData} />
            </Card.Body>
          </Card>
        </Col>

        <Col xl={6}>
          <Card className="shadow-sm">
            <Card.Header>
              <h5 className="mb-0">Shop Distribution</h5>
            </Card.Header>
            <Card.Body>
              <Pie data={pieChartData} />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Business Status */}
      <Row className="mt-4">
        <Col xl={12}>
          <Card className="shadow-sm border-0 rounded-3 bg-light">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <h5 className="text-dark mb-1">Business Status</h5>
                <p className="mb-0 fw-semibold">
                  Active: {dashboardCounts.businessStats.active}, Inactive: {dashboardCounts.businessStats.inactive}
                </p>
              </div>
              <div className="text-end">
                <span className="badge bg-success me-2">Active</span>
                <span className="badge bg-danger">Inactive</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Banner Cards */}
      <Row className="mt-4">
        <h4 className="mb-3 fw-semibold">Banners</h4>
        {dashboardCounts.banners.map((banner, index) => (
          <Col md={4} key={index} className="mb-4">
            <Card className="shadow-sm border-0 h-100 rounded-4">
              <Card.Body className="d-flex gap-3 align-items-start">
                <Image
                  src={banner.img}
                  rounded
                  width={90}
                  height={60}
                  style={{ objectFit: 'cover', borderRadius: '10px', border: '1px solid #ddd' }}
                  alt={banner.title}
                  onError={(e) => e.target.src = "https://via.placeholder.com/90x60?text=No+Image"}
                />
                <div className="flex-grow-1">
                  <h6 className="mb-1 fw-bold text-dark">{banner.shop}</h6>
                  <p className="mb-1 text-primary fw-semibold">{banner.title}</p>
                  <p className="mb-2 text-muted small">{banner.description}</p>
                  <span className={`badge ${banner.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                    {banner.status}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Dashboard;
